import { assetUrl } from '../../lib/assetUrl';

/**
 * @param {{ service: import('../../data/services').Service }} props
 */
export default function ServiceCard({ service }) {
  const { title, description, image } = service;

  return (
    <li className="service-card">
      <div className="service-card__media">
        <img src={assetUrl(image)} alt={title} loading="lazy" />
      </div>
      <div className="service-card__body">
        <h3>{title}</h3>
        <p className="muted">{description}</p>
      </div>
    </li>
  );
}
